/**
 * Este documento ha sido desarrollado por Pulsar Inara S.L.U.
 * Para más información: info@pulsarinara.com
 * URL www.pulsarinara.com
 * Todos los derechos reservados.
 *
 * This document has been developed by Pulsar Inara S.L.U.
 * For more information: info@pulsarinara.com
 * URL www.pulsarinara.com
 * All rights reserved.
 *
 * Copyright 2015 Pulsar Inara, S.L.U.
 *
 * @package    jquery.validator
 * @author     Pulsar Inara <info@pulsarinara.com> D3
 * @version    0.100 2015-02-09
 * @copyright  Copyright (c) 2015, Pulsar Inara, S.L.U.
 */
(function ($) {

    //@formatter:off
    var
    // Default settings object.
    defaults =
    {
        oneByInput : true,      // only check validations until first error in each input (to dont show two errors in same input)

        onBlur    : false,      // onBlur -> onChange
        onChange  : false,      // when input change auto validate
        onKeyUp   : true,       // evalue item on keyUp when a previous validation was failed (to remove alert)
        onError   : null,       // callback to return on each failed rule
        onPassed  : null,       // callback to return on each successfull rule
        onSuccess : null,       // callback to return when all validations are finished OK
        },
        error     = false,        // store boolean for indicate when validation have errors
        errors    = [],                // store an array of fields with errors. Any field will be another array with rule errors
        isNumeric = false,         // store boolean for indicate if field under validation is considerate numeric

    // Abstracting the HTML and event identifiers for easy rebranding
    validator = 'validator',
    prefix         = 'vldtr_',
    boxElement     = prefix + 'Element',

    // Events
    event_open           = prefix + '_open',
    event_load           = prefix + '_load',
    event_complete     = prefix + '_complete',
    event_cleanup     = prefix + '_cleanup',
    event_closed       = prefix + '_closed',
    event_purge       = prefix + '_purge',

    // Cached jQuery DOM Object Variabl
    $form,
    $events = $( '<a/>' ),

      // Variables for cached values or use across multiple functions
      settings,
      labels,
      publicMethod,
      alerts,
      div = "div",
      init;


    // Assigns function results to their respective properties
    function makeSettings( options )
    {
      var options = options || {};

      return $.extend( defaults, options );
   }


    function parseDate(dateStr) {
    //format check
    var m = dateStr.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
    if(!m) return null;

    var date;
    //parse with jquery ui's date picker
    if($.datepicker !== undefined) {
      try {
        var epoch = $.datepicker.parseDate("dd/mm/yy", dateStr);
        date = new Date(epoch);
      } catch(e) { return null; }
    //simple regex parse
    } else {
      date = new Date(parseInt(m[3], 10),parseInt(m[2], 10)-1,parseInt(m[1], 10));
    }
    return date;
  }


  /*
   * function to call for each rule
   */
    var rules =
    {
        /*
         * input must be checked
         */
        accepted : function(item) {
            return item.is(':checked');
        },

        /*
         * input must be only alpha characteres (no numbers or other characters)
         */
        alpha : function(item) {
            return item.val().match(rulesInfo.alpha.regex);
        },

        /*
         * input must be only alpha characteres or dash and under dash (i.e. alpha-dash_)
         */
        alpha_dash : function(item) {
            return item.val().match(rulesInfo.alpha_dash.regex);
        },

        /*
         * input must be only alphanumeric characteres
         */
        alpha_num : function(item) {
            return item.val().match(rulesInfo.alpha_num.regex);
        },

        between : function($item, min, max)
        {
            if (isNumeric)
            {
                var value = parseFloat($item.val());
                min       = parseFloat(min);
                max       = parseFloat(max);
                return (value >= min && value <= max);
            }
            else
            {
                return ($item.val().length >= min && $item.val().length <= max);
            }
        },
        confirmed : function($item)
        {
            var id = $item.attr('id');
            var $item_confirmation = $('#'+id+'_confirmation');

            return $item.val() == $item_confirmation.val();
        },
        date : function($item)
        {
      if ( parseDate( $item.val( ) ) )
        return true;
      return false;
        },
        numeric : function(item)
        {
            return item.val().match(rulesInfo.numeric.regex);
        },
        /*
         * input must be numeric and have an exactly number of digits
         * separator (, or .) doesnt count for digits
         */
        digits : function($item, digits) {
            var number = $item.val().replace(',', '').replace('.','');
            return rules['numeric']($item) && number.length == digits;
        },
        /*
         * input must be a string formated as email
         */
        email    : function($item) {
            //console.log($item.val(), rulesInfo.email.regex, $item.val().match(rulesInfo.email.regex));
            return $item.val().match(rulesInfo.email.regex);
        },
        in : function($item, list) {
            return $.inArray($item.val(), list) != -1;
        },
        /*
         * input must be a integer
         */
        integer : function($item) {
            return $item.val().match(rulesInfo.integer.regex);
        },
        /*
         * input must be a real number
         */
        real_num : function($item) {
            return $item.val().match(rulesInfo.real_num.regex);
        },
        /*
         * input must be a natural number
         */
        nat_num : function($item) {
            return $item.val().match(rulesInfo.nat_num.regex);
        },
        /*
         * input must be a upper case mac address
         */
        mac_address : function($item) {
            return $item.val().match(rulesInfo.mac_address.regex);
        },
        /*
         * input musb be formated as IP (v4 or v6)
         */
        ip : function($item) {
            //console.log($item.val().match(rulesInfo.ip.regexV4), $item.val().match(rulesInfo.integer.regexV6));
            return $item.val().match(rulesInfo.ip.regexV4) || $item.val().match(rulesInfo.ip.regexV6);
        },
        max : function($item, max) {
            if (isNumeric)
            {
                var value = parseFloat($item.val());
                max       = parseFloat(max);
                return value <= max;
            }
            else
            {
                return $item.val().length <= max;
            }
        },
        min : function($item, min) {
            if (isNumeric)
            {
                var value = parseFloat($item.val());
                min       = parseFloat(min);
                return value >= min;
            }
            else
            {
                return $item.val().length >= min;
            }
        },
        not_in : function($item, list) {
            return $.inArray($item.val(), list) == -1;
        },
        /*
         * input value is required
         */
        required : function(item) {
            var field = item;//item.field;
            var v     = item.val( );

            switch (item.prop("type"))
            {
                case "radio":
                case "checkbox":
                    var name  = field.attr( "name" );
                    var group = field.data( 'fieldGroup' );
                    if ( !group ) {
                        group = $form.find( "input[name='" + name + "']" );
                        field.data( 'fieldGroup', group );
                    }
                    if ( group.is( ":checked" ) )
                        break;

                    if ( group.length === 1 )
                        return false;

                    return false;
                default:
                    if ( ! $.trim( v ) )
                    return false;
                    break;
            }
            return true;
            },
        size : function(item, size) {
            if (isNumeric)
            {
                var value = parseFloat($item.val());
                size      = parseFloat(size);
                return value = size;
            }
            else
            {
                return $item.val().length = size;
            }
        },
        string : function($item) {
            return jQuery.type( $item.val() ) === "string";
        },
        url : function($item) {
            return $item.val().match(rulesInfo.url.regex);
        },
        /*
         * make a callback to a function
         * THIS DOESNT WAIT FOR ANSWARE! callback must handle response
         */
        callback : function($item, param)
        {
            /*
             * make call to function
             */
            params = param.split(":");
            if(params[2]){
                var callback = params[0];
                return eval(callback+"(params[1],params[2])");
            }else if(params[1]){
                var callback = params[0];
                return eval(callback+"(params[1])");
            } else {
                return eval(params+"()");
            }
            // return true;
        }
    };

  var rulesInfo =
  {
    /* Regex validators
     * - at plugin load, 'regex' will be transformed into validator function 'fn' which uses 'message'
     */
    currency :
    {
      regex : /^\-?\$?\d{1,2}(,?\d{3})*(\.\d+)?$/,
      message : "Invalid monetary value"
    },
    email :
    {
      regex : /^(([^<>()\[\]\\.,;:\s@\"]+(\.[^<>()\[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      message : "Invalid email address"
    },
    url :
    {
      regex : /^https?:\/\/[\-A-Za-z0-9+&@#\/%?=~_|!:,.;]*[\-A-Za-z0-9+&@#\/%=~_|]/,
      message : "Invalid URL"
    },
    alpha :
    {
      regex : /^[A-Za-z]+$/,
      message : "Use letters only"
    },
    alpha_dash :
    {
      regex : /^[A-Za-z_-]+$/,
      message : "Use letters only"
    },
    alpha_num :
    {
      regex : /^[0-9A-Za-z]+$/,
      message : "Use digits and letters only"
    },
    street_number :
    {
      regex : /^\d+[A-Za-z]?(-\d+)?[A-Za-z]?$/,
      message : "Street Number only"
    },
    integer :
    {
        regex     : /^[\d]+$/,
        message : "Use number onley"
    },
    mac_address :
    {
        regex     : /^([0-9A-F]{2}:){5}([0-9A-F]{2})*$/,
        message : "Upper capitalice MAC Address"
    },
    real_num :
    {
        regex     : /^[\-\d]+[\.\d]*$/,
        message : "Use number only"
    },
    nat_num :
    {
        regex     : /^[\d]*$/,
        message : "Use natural number only"
    },
    ip :
    {
        regexV4 : /^((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])$/,
        regexV6    : /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/,
        message : "Use number onley"
    },
    numeric :
    {
      regex : /^\d*((\.|,)\d*)?$/,
      message : "Use number or number with decimals only"
    },
    numberSpace :
    {
      regex : /^[\d\ ]+$/,
      message : "Use digits and spaces only"
    },
    postcode :
    {
      regex : /^\d{4}$/,
      message : "Invalid postcode"
    },
    date :
    {
      message : "Invalid date"
    },
    required :
    {
      messages :
      {
        "all"             : "This field is required",
        "multiple"     : "Please select an option",
        "single"         : "This checkbox is required"
      }
    },
    regex :
    {
      fn : function( r )
      {
        var re;
        try
        {
          var str = r.args [ 0 ];
          re = new RegExp( str );
        } catch(error)
        {
          r.warn( "Invalid regex: " + str );
          return true;
        }
        if ( !r.val( ).match( re ) )
          return r.args [ 1 ] || r.message;
        return true;
      },
      message : "Invalid format"
    },
    //an alias
    pattern :
    {
      extend : 'regex'
    },
    asyncTest : function( r )
    {
      r.prompt( r.field, "Please wait..." );
      setTimeout( function( )
      {
        r.callback( );
      }, 2000 );
    },
    phone : function( r )
    {
      r.val( r.val( ).replace( /\D/g, '' ) );
      var v = r.val( );
      if ( !v.match( /^\+?[\d\s]+$/ ) )
        return "Use digits and spaces only";
      if ( v.match( /^\+/ ) )
        return true;
      //allow all international
      if ( !v.match( /^0/ ) )
        return "Number must start with 0";
      if ( v.replace( /\s/g, "" ).length !== 10 )
        return "Must be 10 digits long";
      return true;
    },
    minAge : function( r )
    {
      var age = parseInt( r.args [ 0 ], 10 );
      if ( !age || isNaN( age ) )
      {
        //console.log( "WARNING: Invalid Age Param: " + age );
        return true;
      }
      var currDate = new Date( );
      var minDate = new Date( );
      minDate.setFullYear( minDate.getFullYear( ) - age );
      var fieldDate = $.verify.utils.parseDate( r.val( ) );
      if ( fieldDate === "Invalid Date" )
        return "Invalid Date";
      if ( fieldDate > minDate )
        return "You must be at least " + age;
      return true;
    }

  };

  /**
   * complete form evaluation
   *
   * @param DOMObject $form
   */
  var evaluateForm = function($form) {
      $items = $form.find('[data-validate]');

      console.log('evaluateForm', $form, $items);

      error = false;

      $items.each(function(index, item) {
          //console.log(index, item);
          var $item = $(item);
          evaluateItem($item);
      });
  };


    /**
     * evaluation of a single item
     *
     * @param DOMObject    $item
     */
  var evaluateItem = function($item)
  {
      console.log($item.attr('data-validate'));
        if ($item.attr('data-validate'))
          {
              var rulesString     =    $item.attr('data-validate');
              var rulesArray      = rulesString.split('|');
              var ruleAsync     = null;
              var errorsForItem    = 0;
              isNumeric                 = false;

              $.each(rulesArray, function(index, rule) {

                  var params = getParams(rule);

                  rule              = rule.indexOf(':') != -1 ? rule.substr(0, rule.indexOf(':')) : rule;

                  if (rule != 'unique')
                  {
                      var result = evaluateRule($item, rule, params);

                      // //console.log('[VALIDATOR] rule', rule, result);

                      errorsForItem += result ? 0 : 1;

                        /*
                         * if oneByInput then doesnt check more validations in this input after first error
                         */
                        if (!result && settings.oneByInput)
                        {
                            return false;
                        }
                    }
                    else
                    {
                        ruleAsync = {rule: rule, params: params};
                    }
              });

              if (ruleAsync)
              {
                  evaluateAsync($item, ruleAsync, rulesArray, errorsForItem, onComplete);
              }
              else
              {
                  onComplete($item, rulesArray, errorsForItem);
              }
          }
  };

  var onComplete = function($item, rulesArray, errors)
  {
      // //console.log(errors);
        /*
         * if all rules for this input are passed then make callback to onPassed
         */
        if (errors == 0 && settings.onPassed)
        {
            settings.onPassed($item.attr('id'), rulesArray);
        }
  };

  var evaluateRule = function($item, rule, params)
  {
        if (rules[rule])
        {
            /*
             * if rule is in or not_in we pass all params in array
             */
            if (rule == 'in' || rule == 'not_in')
            {
                var result = rules[rule]($item, params);
            }
            else
            {
                var result = rules[rule]($item, params[0], params[1]);
            }
            var id = $item.attr('id');

            handleResult($item, rule, result);
            return result;
        }
        else
        {
            //console.log('[VALIDATOR] - Rule doesnt exists!');
            return false;
        }
  };

  var handleResult = function($item, rule, result)
  {
      var id = $item.attr('id');
        if ( !result )
        {
            addError(id, rule);

            if (settings.onError)
            {
                settings.onError($item.attr('id'), rule);
            }
                      console.log('#'+id+'_'+rule);
            /*
             * if is defined a rule alert then show
             */
            if ( $('#'+id+'_'+rule) )
            {
                $('#'+id+'_'+rule).show().removeClass('hidden');
            }

            $item.removeClass('validateSuccess').addClass('validateFails');

            if (settings.onKeyUp) {
                // on error if onKeyUp is true validate on each keyUp to remove
                // alerts in the moment field is OK without wait for change/blur
                addOnKeyBindings($item);
            }
            return false;
        }
        else
        {
            if (rule == 'numeric')
                isNumeric = true;

            /*
             * if is defined rule alert then hide
             */
            if ( $('#'+id+'_'+rule) )
            {
                $('#'+id+'_'+rule).hide();
            }
            $item.addClass('validateSuccess').removeClass('validateFails');

            if (settings.onKeyUp) {
                // if rule is OK no validate field on each keyUp until next validation
                // fails
                $item.unbind('keyup');
            }

            removeError(id, rule);
        }
  };

    var evaluateAsync = function($item, ruleAsync, rulesArray, errors, callback)
    {
        //console.log('rulesArray', rulesArray);
        var asyncRule = '';

        var rule   = ruleAsync.rule;
        var params = ruleAsync.params;

        rules[rule]($item, params, rulesArray, errors, callback);
    };


  /**
   * return params from validation rule
   *
   * @param     string     rule
   * @return     false|array
   */
  var getParams = function(rule)
  {
      var index = rule.indexOf(":");
      if (index == -1)
          return false;

      var parameters = rule.substring(index + 1);
      return parameters.split(',');
  };

  /**
   * add error to array
   *
   * @param string    name (ID) of input
   * @param string  rule name
   */
  var addError = function(item, rule)
  {
        //console.log('[VALIDATOR] addError', item, rule, errors, item in errors, typeof errors[item], !errors[item] );

      error = true;

      if (!errors[item]) {
          errors[item] = [];
          errors.push(item);
      }

      //console.log('[VALIDATOR] errors', errors);

      if (!errors[item][rule]) {
          errors[item][rule] = true;
      }

      //console.log('[VALIDATOR] error added', errors, error);
  };

  /**
   * remove error entry (if exists) from errors
   *
   * @param string    name (ID) of input
   * @param string  rule name
   */
  var removeError = function(item, rule)
  {
      //console.log('[VALIDATOR] removeError', item, rule);

      if (errors[item] && errors[item][rule])
          delete errors[item][rule];

      if (errors[item] && errors[item].length == 0)
          delete errors[item];

      if (errors.length == 0)
          error = false;

      //console.log('[VALIDATOR] error removed', errors, error);
  };



  /**
   * if settings onBlur is set to TRUE then add bindings for onChange events for any input with data-validate
   * checkbox respond better to onChange even onBlur so event was changed
   */
  var addOnChangeBindings = function() {
      $items = $form.find('input, select, textarea');

      $items.each(function(index, item) {
          var $item = $(item);
          if ($item.attr('data-validate'))
          {
              // blur changed to change
              $item.blur(function() {
                  evaluateItem($item);
              });
              // blur changed to change
              $item.change(function() {
                  evaluateItem($item);
              });
          }
      });
  };

  /**
   * if settings onKeyUp is set to TRUE then add bindings for input after one validation fails
   */
  var addOnKeyBindings = function($item) {
        $item.unbind('keyup').keyup(function() {
            evaluateItem($item);
        });
  };

  /*
   * construct for chessPlanet
   */
  publicMethod = $.fn [ validator ] = $ [ validator ] = function( options, callback )
  {
      console.log('validator instance', this);

      $form = this;

      settings = makeSettings( options );

      if (!settings.onBlur) {
          publicMethod.validate();
      } else {
          addOnChangeBindings();
      }

      if ( callback ) {
          options.onComplete = callback;
      }

      return $form;
  };

  /**
   * call to validate function
   *
   * $(item).validator.validate();
   */
  publicMethod.validate = function() {
    console.log('validator validate', $form, $form.is('form'));
    if ($form.is('form')) {
        evaluateForm($form);
    } else {
        evaluateItem($form);
    }

    //console.log('onSuccess', error, errors);

    if (!error && settings.onSuccess) {
        settings.onSuccess();
    }
  };

  /**
   * get validation result
   *
   * @return boolean
   */
  publicMethod.fails = function() {
      console.log('fails', $form);
    if ($form.is('form')) {
        evaluateForm($form);
    } else {
        evaluateItem($form);
    }

    return error;
  };

  /**
   * get validation errors
   *
   * @return array
   */
  publicMethod.failed = function() {
      return errors;
  };

  function require_if_type(param, required_type){

      var type = $("#type").val();

      if(type == required_type) {
        if($("#"+param).val() != "") {
            return true;
        } else {
            return false;
        }
      }

      return true;
  }
} )( jQuery );

$(document).ready(function () {
    if($(".required_type").length){
        $( ".required_type" ).change(function() {
            change();
        });

        var change = function () {
            $(".required_for_type").hide();
            $(".required_for_type_" + $("#type").val()).show();
        }

        change();
    }
});
